"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetPassword = void 0;
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const ResetPassword_style_1 = require("./ResetPassword.style");
const GlobalStyles_1 = require("../../../helper/GlobalStyles");
const User_service_1 = __importDefault(require("../../../services/User.service"));
const atome_1 = require("../../atome");
const enums_1 = require("../../../enums");
const hooks_1 = require("../../../store/hooks");
const reducers_1 = require("../../../store/reducers");
const organisms_1 = require("../../organisms");
const Breakpoints_1 = require("../../../helper/Breakpoints");
// @ts-ignore
function ResetPassword({ navigation, route }) {
    const auth = (0, hooks_1.useAppSelector)(reducers_1.selectAuth);
    const [password, setPassword] = (0, react_1.useState)('');
    const [repeatedPassword, setRepeatedPassword] = (0, react_1.useState)('');
    const [error, setError] = (0, react_1.useState)({
        passwordReq: false,
        passwordEqual: false,
        emailTaken: false,
    });
    (0, react_1.useEffect)(() => {
        return navigation.addListener('focus', () => {
            if (auth?.isAuthenticated) {
                navigation.navigate('Dashboard');
            }
            if (!route.params?.token) {
                navigation.navigate('Login');
            }
        });
    }, [auth, navigation]);
    const validate = () => {
        const regex = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])/;
        const newError = {
            passwordReq: !regex.test(password) || password.length < 8,
            passwordEqual: password !== repeatedPassword,
        };
        setError({
            ...error,
            ...newError,
        });
        return newError;
    };
    const resetPassword = async () => {
        const newError = validate();
        if (Object.values(newError).find(e => e)) {
            return;
        }
        const resp = await User_service_1.default.resetPassword({
            token: route.params.token,
            password: password,
        });
        if (!resp.error) {
            navigation.navigate('Login');
        }
        console.log(resp.message);
    };
    return (react_1.default.createElement(react_native_1.SafeAreaView, null,
        react_1.default.createElement(react_native_1.ScrollView, { style: ResetPassword_style_1.styles.scrollView },
            react_1.default.createElement(organisms_1.BaseHeader, { navigation: navigation }),
            react_1.default.createElement(react_native_1.View, { style: ResetPassword_style_1.styles.container },
                react_1.default.createElement(react_native_1.View, null,
                    react_1.default.createElement(atome_1.Text, { style: [ResetPassword_style_1.styles.heading3] }, "Passwort neu setzen"),
                    react_1.default.createElement(atome_1.Label, { style: [ResetPassword_style_1.styles.introText] }, "Bitte w\u00E4hlen Sie ein neues Passwort, mit dem Sie sich bei nowomed einloggen m\u00F6chten."),
                    react_1.default.createElement(react_native_1.View, { style: [
                            Breakpoints_1.isMobile || Breakpoints_1.isTablet ? GlobalStyles_1.globalStyles.column : GlobalStyles_1.globalStyles.row,
                            GlobalStyles_1.globalStyles.marginRow,
                        ] },
                        react_1.default.createElement(atome_1.Label, null, "Passwort"),
                        react_1.default.createElement(react_native_1.View, { style: GlobalStyles_1.globalStyles.flex1 },
                            react_1.default.createElement(atome_1.InputField, { hasError: error.passwordReq, onChange: setPassword, secure: true, value: password, style: Breakpoints_1.isMobile || Breakpoints_1.isTablet ? [ResetPassword_style_1.styles.input] : undefined }),
                            error.passwordReq && (react_1.default.createElement(atome_1.Text, { style: [ResetPassword_style_1.styles.errorText] }, enums_1.ErrorMessages.PASSWORD_REQUIREMENTS)))),
                    react_1.default.createElement(react_native_1.View, { style: [
                            Breakpoints_1.isMobile || Breakpoints_1.isTablet ? GlobalStyles_1.globalStyles.column : GlobalStyles_1.globalStyles.row,
                            GlobalStyles_1.globalStyles.marginRow,
                        ] },
                        react_1.default.createElement(atome_1.Label, null, "Passwort wiederholen"),
                        react_1.default.createElement(react_native_1.View, { style: GlobalStyles_1.globalStyles.flex1 },
                            react_1.default.createElement(atome_1.InputField, { hasError: error.passwordEqual, onChange: setRepeatedPassword, secure: true, value: repeatedPassword, style: Breakpoints_1.isMobile || Breakpoints_1.isTablet ? [ResetPassword_style_1.styles.input] : undefined }),
                            error.passwordEqual && (react_1.default.createElement(atome_1.Text, { style: [ResetPassword_style_1.styles.errorText] }, enums_1.ErrorMessages.PASSWORD_EQUAL))))),
                react_1.default.createElement(react_native_1.View, { style: [
                        GlobalStyles_1.globalStyles.row,
                        GlobalStyles_1.globalStyles.marginRow,
                        ResetPassword_style_1.styles.buttonContainer,
                        GlobalStyles_1.globalStyles.marginTop50,
                    ] },
                    react_1.default.createElement(react_native_1.Pressable, { style: ResetPassword_style_1.styles.button, onPress: resetPassword },
                        react_1.default.createElement(atome_1.Text, { style: [ResetPassword_style_1.styles.buttonText] }, "Passwort setzen")),
                    Object.values(error).find(e => e) && (react_1.default.createElement(atome_1.Text, { style: [ResetPassword_style_1.styles.errorText, ResetPassword_style_1.styles.errorTextBottom25] }, enums_1.ErrorMessages.ERROR)))))));
}
exports.ResetPassword = ResetPassword;
